var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',[_c('article',[_c('h1',[_vm._v("Beach Session")]),(_vm.response)?_c('div',[_vm._v(" "+_vm._s(_vm.response.message)+" ")]):_vm._e()]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }